import React, { useContext, useState } from 'react';
import { Link } from 'gatsby';
import { StoreContext } from '../../context/StoreContext';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { media, TransitionMixin } from '../helpers';

import CollectionAddToCart from './collection-add-to-cart';
import { useEffect } from 'react';

const CollectionGridItemContainer = styled.div`
    margin-bottom: 40px;
    display: flex;
    ${media.medium`margin-bottom: 70px;`}
    >  .inner-wrap {
        flex: 1;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        max-width: 90%;
        > * {
            flex: 1 1 100%;
        }
        a {
            text-decoration: none;
            ${TransitionMixin('.25s')}
            .image-container {
                margin-bottom: 20px;
            }

            &:hover {
                opacity: 0.7;
            }
        }

        .content-container {
            display: inline-flex;
            flex-wrap: wrap;
            > * {
                flex: 1 1 100%;
            }

            .inner-wrap {
                display: flex;
                flex-wrap: wrap;
                align-items: flex-end;
                > * {
                    flex: 1 1 100%;
                }

                .color-swatches-container {
                    margin-bottom: 5px;
                    ul {
                        padding: 0;
                        margin: 0;
                        list-style: none;
                        li {
                            display: inline-block;
                            margin-right: 10px;

                            &:last-child {
                                margin-right: 0px;
                            }

                            button {
                                height: 22px;
                                width: 22px;
                                border-radius: 50%;
                                border: 1px solid #ccc;
                                background-color: #888;

                                &.red {
                                    background-color: red;
                                }
                                &.black {
                                    background-color: black;
                                }

                                &.blue {
                                    background-color: blue;
                                }
                                &.green {
                                    background-color: green;
                                }
                                &.charcoal {
                                    background-color: #222;
                                }
                                &.orange {
                                    background-color: orange;
                                }
                                &.yellow {
                                    background-color: orange;
                                }
                                &.white {
                                    background-color: white;
                                }

                                &.navy {
                                    background-color: navy;
                                }

                                &.purple {
                                    background-color: purple;
                                }
                            }
                        }
                    }
                }

                a {
                    .title-container {
                        display: flex;
                        margin-bottom: 5px;
                        h4 {
                            flex: 3;
                            color: #000;
                            margin: 0;
                            line-height: 1.3;
                        }
                        p {
                            flex: 1;
                            text-align: right;
                            margin: 0;
                            color: #0f1212;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }
`;

const CollectionGridItem = ({ product }) => {
    const { title, handle } = product;
    const [currentVariant, setCurrentVariant] = useState();

    const { colorHandlize } = useContext(StoreContext);

    const variantPrice =
        currentVariant && currentVariant.price.replace('.00', '');

    // check for color variant
    let productColors = [];

    product.variants.map((variant) => {
        variant.selectedOptions.map((option) => {
            if (option.name === 'Color') {
                return productColors.push(option.value);
            }

            return;
        });
    });

    // then remove duplicates
    productColors = new Set(productColors);
    productColors = [...productColors];

    function handleVariantChange(color) {
        let matchingVariants = [];
        product.variants.map((variant) => {
            variant.selectedOptions.map((option) => {
                if (option.value === color) {
                    return matchingVariants.push(variant);
                }

                return;
            });
        });

        setCurrentVariant(matchingVariants[0]);
    }

    let editedTitle = product.title
        .replace('Necktie', '')
        .replace('Bow Tie', '')
        .replace('Pocket Square', '')
        .replace('Face Mask', '')
        .replace('Neck Gaiter', '');

    useEffect(() => {
        setCurrentVariant(product.variants[0]);
    }, []);

    return (
        <CollectionGridItemContainer>
            <div className="inner-wrap">
                <Link to={`/products/${handle}`}>
                    <div className="image-container">
                        <Img
                            fluid={
                                product.images[0].localFile.childImageSharp
                                    .fluid
                            }
                        />
                    </div>
                </Link>
                <div className="content-container">
                    <div className="inner-wrap">
                        <Link to={`/products/${handle}`}>
                            <div className="title-container">
                                <h4>{editedTitle}</h4>
                                <p>${variantPrice}</p>
                            </div>
                        </Link>
                        <CollectionAddToCart handle={handle} />
                    </div>
                </div>
            </div>
        </CollectionGridItemContainer>
    );
};

export default CollectionGridItem;
